/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReverseDelegateTransferRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/reverse_delegate_transfer.pb'
import {ReverseDelegateTransferResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/reverse_delegate_transfer.pb'


export const reverseDelegateTransfer = (request: ReverseDelegateTransferRequest, options?: CashRequestOptions) => post<ReverseDelegateTransferRequest, ReverseDelegateTransferResponse>("/2.0/cash/reverse-delegate-transfer", request, {...options, rejectOnError: true })